import Vue from 'vue';
import { Component, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DayInfo } from '@/models/task-day';
import { __values } from 'tslib';
import { MessageType } from '@/models/message-type';
import { Employee, Project } from '@/types/store-types';

const project = namespace('project');

@Component({ components: {} })
export default class DayComponent extends Vue {
  private isLoading = false;

  private hasError = false;

  private currentValue = 0;

  private error = true;

  private valid = true;

  @Prop()
  private tabIndex: number;

  @Prop()
  private dayInfo: DayInfo;

  @project.Getter('project')
  private project: Project;

  get isWeekend(): boolean {
    return this.dayInfo.day.getDay() === 0 || this.dayInfo.day.getDay() === 6;
  }

  get disabled(): boolean {
    if (this.project.endDate && this.dayInfo.day.getTime() > this.project.endDate.getTime()) {
      return true;
    }

    return this.dayInfo.disabled;
  }

  get value(): string {
    return this.currentValue === undefined || this.currentValue === null || this.currentValue === 0 ? '' : this.currentValue.toString();
  }

  set value(hours: string) {
    this.currentValue = hours === '' ? 0 : Number(hours);
  }

  private mounted() {
    this.isLoading = true;
    this.currentValue = this.dayInfo.plannedHours;
    this.isLoading = false;
  }

  private noMinus(e: Event) {
    e.preventDefault();
  }

  get errorText(): string {
    if (this.valid) {
      return '';
    }

    return this.$t('day.invalidhours').toString();
  }

  @project.Action('updateDay')
  private async saveHours(day: DayInfo) {
  }

  private async submitChanges() {
    this.valid = Number(this.currentValue) <= 24 && Number(this.currentValue) >= 0;
    if (!this.valid) {
      return;
    }

    if (this.currentValue !== this.dayInfo.plannedHours) {
      try {
        const day = { ...this.dayInfo };
        day.plannedHours = this.currentValue;
        this.isLoading = true;
        await this.saveHours(day).catch((error) => {
          this.hasError = true;
          this.currentValue = this.$data.plannedHours;
          this.$store.commit('setMessage', error.response !== undefined ? error.response.data : { type: MessageType.Error, message: error.message });
        }).finally(() => {
          this.isLoading = false;
          setTimeout(() => { this.hasError = false; }, 3000);
        });
      } catch {
      }
    }
  }
}
